var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.526c.431 0 .781.35.781.78v5.21a.781.781 0 1 1-1.562 0v-5.21c0-.43.35-.78.781-.78ZM12.994 17.859a.781.781 0 1 0 0 1.562h.01a.781.781 0 0 0 0-1.562h-.01Z",
    fill: "#CC4949"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.872 24.015H6.688c-1.98 0-3.576-.714-4.373-2.072-.797-1.357-.644-3.1.314-4.828l3.25-5.854 3.063-5.5c1.003-1.81 2.444-2.91 4.058-2.91 1.615 0 3.054 1.1 4.058 2.91l6.313 11.364c.958 1.73 1.108 3.472.31 4.83-.798 1.356-2.394 2.07-4.369 2.07H13a.782.782 0 0 1-.128-.01ZM13 4.414c-.833 0-1.841.571-2.692 2.105l-3.062 5.5-3.25 5.854c-.792 1.429-.759 2.556-.334 3.28.424.722 1.39 1.3 3.026 1.3H13c.044 0 .086.003.128.01h6.184c1.63 0 2.597-.577 3.022-1.301.426-.724.462-1.85-.33-3.278L15.692 6.52c-.85-1.534-1.859-2.106-2.692-2.106Z",
    fill: "#CC4949"
  })));
};
export default SvgWarning;